export default __webpack_public_path__ + "static/media/coin_20gm.9707aac8.jpg";